;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';
	var View = APP.module('View');
	View.PasswordRecovery = Marionette.ItemView.extend({
		tagName: 'div',
		ui: {
			'submit': '#js-revovery-password'
		},
		events: {
			'click @ui.submit': 'changePassword'
		},
		initialize: function() {
			this.errors = false;
			this.form = new Backbone.Form({
				template: JST.PasswordRecovery,
				model: this.model
			});

			this.listenTo(this.form, 'password:change password:blur passwordConfirm:change passwordConfirm:blur', this.changeAndBlur);
		},
		render: function(){
			this.$el.html(this.form.render().el);
			return this;
		},
		changeAndBlur: function(form, editor){
			if(!editor.getValue()){
				this.errors = true;
				$(editor.el).removeClass('valid');
				$(editor.el).parents('.error').removeClass('error');
				$(editor.el).parent().next('div').html('');
				return;
			}
			var errs = this.form.fields[editor.key].validate();
			if(errs){
				this.errors = true;
			}
			else {
				this.errors = false;
			}
			!errs && editor.previousValue ? $(editor.el).addClass('valid') : $(editor.el).removeClass('valid');
			return this;
		},

		changePassword: function() {
			this.errors = this.form.validate();
			this.showPreloader();
			if(!this.errors){
				this.model.set('password', this.form.getValue('password'));
				$.when.call(null , this.model.save()).done(_.bind(function(response){
					if(response.errors.length){
						this.errorsProcessor(response.errors);
						this.hidePreloader(response.errors);
					}
					else {
						APP.vent.trigger('user:login', response.result);
						APP.vent.trigger('popup:message:show', 'Your password successfully changed!');
					}
				}, this));
			}
			else {
				this.hidePreloader();
			}
			return this;
		},
		errorsProcessor: function(errors){
			var error = errors[0];

			if(error.param === 'token'){
				this.showErrors(errors);
				Backbone.history.navigate('forgot-password', { trigger: true });
			}
			else {
				this.showErrors(errors);
				Backbone.history.navigate('login', { trigger: true });
			}

		}
	});

}(window, APP, Backbone, Marionette, $, _));